import { EventBusEvent } from '../enums/EventBus';
import eventBus from '../event-bus/EventBus';
import type { GraphqlNavigationItemProps, NavigationItemProps } from '../types/NavigationItem';

export const is2DArray = <T>(array: any): array is T[][] =>
  Array.isArray(array) && Array.isArray(array[0]);

export const transformTopNavItems = (
  items: GraphqlNavigationItemProps[] | NavigationItemProps[][]
): NavigationItemProps[][] => {
  if (is2DArray(items)) {
    return items;
  }

  const aggregation = items.reduce(
    (acc, item) => {
      if (item.promoImg || item.html) {
        return { ...acc, promo: [...acc.promo, item] };
      }

      return {
        ...acc,
        menu: [
          ...acc.menu,
          {
            ...item,
            children: [[...item.children]],
          },
        ],
      };
    },
    { menu: [], promo: [] }
  );

  return aggregation.promo.length > 0
    ? [[...aggregation.menu], [...aggregation.promo]]
    : [[...aggregation.menu]];
};

export enum SideNavType {
  Global = 'global',
  ShopInShop = 'shop-in-shop',
}

export interface SideNavEvent {
  isOpen: boolean;
  selectedItem?: string;
  type?: SideNavType;
  activeTab?: string;
}

type OpenSideNavParams = Omit<SideNavEvent, 'isOpen'>;

export const openSideNav = ({
  selectedItem,
  type = SideNavType.Global,
  activeTab,
}: OpenSideNavParams = {}) =>
  eventBus.emit<SideNavEvent>(EventBusEvent.ToggleSideNav, {
    isOpen: true,
    selectedItem,
    type,
    activeTab,
  });
